import { Flex, Typography, List, type ListRef } from '@banhala/ui-kit';
import { useAtomValue, useSetAtom } from 'jotai';
import { searchHelperFilterAtom } from '../../states/searchHelperFilter.atom';
import { useRef } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks/useLogAnalyticsEvent';
import { Accessibility } from '../../../../utils/accessibility';

type AgeItem = {
  name: string;
  value: number;
};

export const AgeFilter = () => {
  const filter = useAtomValue(searchHelperFilterAtom); // 읽기 전용
  const setFilter = useSetAtom(searchHelperFilterAtom); // 쓰기 전용
  const logAnalyticsEvent = useLogAnalyticsEvent();

  const ages = filter.ageFilters;
  const selectedAge = filter.selectedAge;

  const listRef = useRef<ListRef<AgeItem> | null>(null);

  return (
    <List
      ref={listRef}
      horizontal
      data={ages}
      keyExtractor={item => String(item.value)}
      showsHorizontalScrollIndicator={false}
      keyboardShouldPersistTaps="handled"
      contentContainerStyle={{
        paddingHorizontal: 16,
        paddingVertical: 2,
      }}
      renderItem={({ item: age, index }) => {
        const selected = selectedAge === age.value;

        return (
          <Flex
            testID={Accessibility.Search.ageFilter(age.name)}
            // 큰 글꼴 설정 기기(Android allowFontScaling)에서 글자 확대로 칩 높이가 늘어나는 것 방지.
            // 칩 높이를 고정하고 텍스트를 세로 중앙 정렬 (ENABLE-1109)
            height={34}
            justifyContent="center"
            margin={{ right: 8 }}
            padding={{ horizontal: 12 }}
            borderRadius={18}
            borderWidth={1}
            borderColor={selected ? 'border_slate_primary' : 'gray30'}
            backgroundColor={selected ? 'bg_slate_primary' : 'bg_always_white'}
            onPress={() => {
              logAnalyticsEvent({
                name: 'CLICK_POPULAR_SEARCH_KEYWORD_AGE_FILTER',
                channel: ['firebase', 'amplitude', 'facebook', 'ablylog'],
                analytics: {
                  AGE_GROUP: age.name,
                },
              });
              setFilter(prev => ({
                ...prev,
                selectedAge: age.value,
              }));
              listRef.current?.scrollToIndex({
                index,
                animated: true,
                viewPosition: 0.5,
              });
            }}
          >
            {/* 라벨("전체"/"20대" 등)은 개행될 일이 없어 numberOfLines 불필요.
                Fabric에서 flex 없는 Text가 너비 과소할당되어 말줄임되던 것 제거 (ENABLE-1109) */}
            <Typography
              type="subtitle3"
              color={selected ? 'content_always_white' : 'content_secondary'}
            >
              {age.name}
            </Typography>
          </Flex>
        );
      }}
    />
  );
};
